import { createExtensionDataRef, createExtensionBlueprint } from '@backstage/frontend-plugin-api';

const formDecoratorExtensionDataRef = createExtensionDataRef().with({
  id: "scaffolder.form-decorator-loader"
});
const FormDecoratorBlueprint = createExtensionBlueprint({
  kind: "scaffolder-form-decorator",
  attachTo: { id: "api:scaffolder/form-decorators", input: "formDecorators" },
  dataRefs: {
    formDecoratorLoader: formDecoratorExtensionDataRef
  },
  output: [formDecoratorExtensionDataRef],
  *factory(params) {
    yield formDecoratorExtensionDataRef(params.decorator);
  }
});

export { FormDecoratorBlueprint };
//# sourceMappingURL=FormDecoratorBlueprint.esm.js.map
